import usePolicies from '@hooks/usePolicies';
import useArticle, { Article } from 'vl-common/src/hooks/useArticle';


/**
 * This is a wrapped version of the vl-common useArticle hook.
 * This version fetches the user policies and determines whether all policies have been accepted for a user that is
 * logged in.
 * The base useArticle is used with vl-admin in the log in screen and does not require any policy data, whereas the
 * shared hook does accept policy data.
 * @param category
 * @param noAuthFallback
 */
export const useArticleWrapped = (category: string, noAuthFallback = false) => {
  const policies = usePolicies();
  return useArticle(category, policies, noAuthFallback);
};

export type { Article };
